var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackArrowDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4,
    height: 2,
    viewBox: "0 0 1.058 0.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -296.47)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.936,
    cy: 293.434,
    r: 0.959,
    stroke: "#fff",
    strokeWidth: 0.236
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.039 296.516l.482.41.5-.407",
    stroke: "#000",
    strokeWidth: 0.11
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackArrowDown);
export default __webpack_public_path__ + "static/media/black-arrow-down.1b4830682a72dd3587faf3e7fd70d423.svg";
export { ForwardRef as ReactComponent };